import React from 'react';
import { opsGetProspectList } from 'api/operation';
import { TOpsClient } from 'types/common';

const useOpsPatient = (): [TOpsClient[], boolean, () => void] => {
    const [data, setData] = React.useState<TOpsClient[]>([]);
    const loading = React.useRef(false);
    const fetchData = async () => {
        try {
            loading.current = true;
            const result = await opsGetProspectList();

            if (!result.error) {
                const _data = result?.data?.data || [];
                setData(_data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        if (!loading.current) {
            fetchData();
        }
    }, []);

    return [data, loading.current, fetchData];
};

export default useOpsPatient;
